import jsPDF, { jsPDFAPI } from "jspdf";
import { BasePDFNode, getYoga, RectPDFNode, TextPDFNode } from "./BasePDFNode";
import { RangedKanaal, RangedKanaalAssign } from "../props/PropTypes";
import { HdwLayout, Kaart } from "../kanaal/hdw-config/HdwSysteem";
import { getAssignment, kanaalLabelHdw } from "../kanaal/kanaal.utils";
import { BoltPDFNode, DipSwitch, IOLine } from "./KaartPartsNodes";
import { IOKlemPDFNode } from "./KaartPDFNode";


export class RackXTPDFNode extends RectPDFNode {
    constructor(public pdf: jsPDF, public kanaalMap: Record<string, Array<Array<RangedKanaalAssign>>>, public kaart: Kaart, public rotated: boolean = false) {
        super(pdf, {
            flexDirection: rotated ? 'row-reverse' : 'row',
            justifyContent: "space-between",
            // margin: 1,
            padding: 1,
            width: 140,
            maxWidth: 140,
            // fillColor: '#E0E000',
            // borderColor: '#E00000'

        }, getYoga().Node.create());

    }

    public init(): void {

        let left = this.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: 'column',
        }))
        left.addChild2(new OpticPort(this.pdf, "P"));
        left.addChild2(new OpticPort(this.pdf, "Q"));
        left.addChild2(new Analyzer(this.pdf));
        left.addChild2(new OpticPort(this.pdf, "S"));
        let container = left.addChild2(new IOKlemPDFNode(this.pdf, this.kanaalMap, this.kaart.getHdwLayout(), false, this.rotated));
        let right = this.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: 'column',
            rowGap: 3
        }));
        let txt = right.addChild2(new TextPDFNode(this.pdf, {
            fontSize: 10

        }));
        txt.text = `Pos ${this.kaart.number} - ${this.kaart.type.label}`;

        super.init();

    }
}

export class OpticPort extends BasePDFNode {
    constructor(public pdf: jsPDF, public name: string) {
        super(pdf, {
            flexDirection: 'row',
            alignItems: "center",
            rowGap: 1,
            width: 14,
            margin: 1

        }, getYoga().Node.create());

    }

    public init(): void {
        let bolts = this.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: 'column',
            justifyContent: 'space-around',
            height: 15
        }));
        bolts.addChild2(new BoltPDFNode(this.pdf, {
            width: 3,
            height: 3,
            fillColor: undefined

        }, true));
        bolts.addChild2(new BoltPDFNode(this.pdf, {
            width: 3,
            height: 3,
            fillColor: undefined

        }, true));
        let c1 = this.addChild2(new RectPDFNode(this.pdf, {
            flexDirection: 'column',
            alignItems: "center",
            rowGap: 1,
            width: 10,
            margin: 1
        }));
        let TxP = c1.addChild2(new TextPDFNode(this.pdf));
        TxP.text = `Tx${this.name}`;
        let P = c1.addChild2(new TextPDFNode(this.pdf, {
            fontSize: 14
        }));
        P.text = this.name;
        let RxP = c1.addChild2(new TextPDFNode(this.pdf));
        RxP.text = `Rx${this.name}`;
    }
}


export class Analyzer extends BasePDFNode {
    constructor(public pdf: jsPDF) {
        super(pdf, {
            flexDirection: 'row',
            marginLeft: 1,
            marginTop: 2,
            marginBottom: 2,
            
        }, getYoga().Node.create());
    }
    public init(): void {

        let pins = this.addChild2(new RectPDFNode(this.pdf,
            {
                flexDirection: 'column',
                alignItems: "center",
                // marginBottom: 1,
                paddingBottom: 1,
                width: 5

            }
        ));

        let text = this.addChild2(new TextPDFNode(this.pdf, {vertical: true, fontSize: 6, marginLeft: 2, top: -2}));
        text.text = "ANALYZER";
        for (let i = 0; i < 5; i++) {
            let c = pins.addChild2(new BasePDFNode(this.pdf, {
                flexDirection: 'row',
                height: 2,
                alignContent: 'center',
                alignItems: 'center',
                width: 5,
                justifyContent: 'space-around',

            }));
            c.addChild2(new BoltPDFNode(this.pdf, {
                width: 1,
                height: 1,
                fillColor: "#000000"

            }));
            c.addChild2(new BoltPDFNode(this.pdf, {
                width: 1,
                height: 1,
                fillColor: "#000000"

            }));
        }
    }
}

